exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attention[data-v-043f7bb8] {\n  color: #e4442f;\n  font-size: 1rem;\n}\n.tel-hyphen[data-v-043f7bb8] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 5px;\n}\n", ""]);

// exports
